const SectionBlock = ({ title, text }) => {
  return (
    <div>
      <h2 style={{ padding: "0px", fontWeight: "400" }}>{title}</h2>
      <p className="text">{text}</p>
    </div>
  );
};

export default SectionBlock;
